import { Button, Card, Tabs } from "antd";
import DashboardTemplate from "../../../templates/Dashboard";
import Header from "../../../atoms/Header";
import { NeedHelp, UploadIcon } from "../../../atoms/CustomIcons";
import { useEffect } from "react";
import { getLaborRate } from "./ducks/actions";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import HourlyRatesTab from "./Components/TabsItems/HourlyRatesTab";
import EmptyCard from "../../../atoms/EmptyCard";

export default function LaborHourlyRates() {
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];

  const laborData = useAppSelector((state) => state?.laborRates?.laborData);

  useEffect(() => {
    if (companyId) {
      dispatch(getLaborRate(companyId));
    }
  }, [companyId, dispatch]);

  return (
    <DashboardTemplate loading={laborData?.loader}>
      <Header
        breadcrumb={[
          { label: "Company settings", href: `/company-settings/${companyId}` },
          { label: "Labor hourly rates" },
        ]}
        title="Labor hourly rates"
        description="Set average labor rates to factor labor costs into estimates."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />

      <div className="exportBtn">
        <Button
          htmlType="button"
          type="default"
          size="large"
          className="outlined-btn white_icon_btn"
        >
          <UploadIcon /> Export labor rates
        </Button>
      </div>
      <Card className="laborHourlyRates">
        {laborData?.data && laborData?.data?.length > 0 ? (
          <Tabs
            tabPosition="left"
            defaultActiveKey="1"
            items={[
              {
                key: "0",
                label: "Service lines",
                disabled: true,
              },
              ...(laborData?.data?.map((e, i: number) => ({
                key: (i + 1).toString(),
                label: e?.name,
                children: <HourlyRatesTab data={e} laborRatesId={e?.id} />,
              })) || []),
            ]}
          />
        ) : (
          <div className="empty_wrap">
            <EmptyCard
              imageHeight={282}
              title="There are no Service lines yet"
              description=""
              image="/images/empty-icons/no-active.svg"
            />
          </div>
        )}
      </Card>
    </DashboardTemplate>
  );
}
